module.exports = __webpack_public_path__ + "img/gr-1.5dc44916.jpg";